import * as React from 'react';
import { useTranslation } from 'hooks';

import { optionsMapper, multiSelectorOptionsMapper } from './utils';

type Option = {
  label: string;
  value: string;
}

const translations = {
  pending: {
    pt: 'Pendente',
    en: 'Pending',
    es: 'Pendiente',
    de: 'Ausstehend',
  },
  approved: {
    pt: 'Aprovado',
    en: 'Approved',
    es: 'Aprobado',
    de: 'Genehmigt',
  },
  rejected: {
    pt: 'Reprovado',
    en: 'Rejected',
    es: 'Rechazado',
    de: 'Abgelehnt',
  },
};

export const useTransporRouteStatusOptions = () => {
  const { getTranslation: t } = useTranslation(translations);

  const options = React.useMemo((): Option[] => {
    return [
      { value: 'pending', label: t('pending') },
      { value: 'approved', label: t('approved') },
      { value: 'rejected', label: t('rejected') },
    ];
  }, [t]);

  return {
    singleSelectOptions: options.map(optionsMapper),
    multiSelectOptions: options.map(multiSelectorOptionsMapper),
  }
}